import Fuse from 'fuse.js';
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { InternalClientTooltip, MultiSelect } from '~/components';
import { useApi, useWorkspace } from '~/contexts';

export default function ProjectGroupFilter({ placeholder = 'Project Group', name, value, onChange }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [data, setData] = useState(null);
  const [options, setOptions] = useState([]);

  const handleSearch = useCallback(
    async (q) => {
      let options = data;
      if (!data) {
        const result = await api.www.workspaces(workspace.id).projectGroups().get();
        setData(result.data);
        options = result.data;
      }
      if (q) {
        options = new Fuse(options, { keys: ['name'], threshold: 0.4 }).search(q).map((result) => result.item);
      }
      setOptions(options);
    },
    [workspace.id, api, data],
  );

  const groups = useMemo(() => {
    if (!options) return null;
    return _(options)
      .orderBy((o) => (value?.some((v) => v.id === o.id) ? 0 : o.isActive ? 1 : 2))
      .groupBy((o) => (value?.some((v) => v.id === o.id) ? 'Selected' : o.isActive ? 'Active' : 'Inactive'))
      .map((projectGroups, status) => ({
        status,
        clients: _(projectGroups)
          .groupBy('client.id')
          .map((clientProjectGroups) => ({
            client: clientProjectGroups[0].client,
            projectGroups: _.orderBy(clientProjectGroups, (o) => (o.isActive ? 0 : 1)),
          }))
          .value(),
      }))
      .value();
  }, [options, value]);

  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      renderOptions={(opts) => {
        const optionsById = _.keyBy(opts, 'id');
        return groups.map(({ status, clients }) => (
          <MultiSelect.Group key={status} label={status}>
            {clients.map(({ client, projectGroups }) => (
              <MultiSelect.Group
                key={client.id}
                label={
                  <div style={{ display: 'flex' }}>
                    {client.name} {client.isInternal && <InternalClientTooltip />}
                  </div>
                }>
                {projectGroups.map((projectGroup) => (
                  <MultiSelect.Option
                    key={projectGroup.id}
                    inactive={!projectGroup.isActive}
                    {...optionsById[projectGroup.id].props}>
                    {projectGroup.name}
                  </MultiSelect.Option>
                ))}
              </MultiSelect.Group>
            ))}
          </MultiSelect.Group>
        ));
      }}
      isLoading={!data}
      onSearch={handleSearch}
      onChange={onChange}
    />
  );
}
